function isKeyPresentInSessionStorage(key) {
  if (typeof sessionStorage !== 'undefined') {
    return sessionStorage.getItem(key) !== null;
  }
  return false;
}
export const DISABLE_APQ_KEY = 'disableAPQ';
export function isAPQDisabledOnWeb() {
  return isKeyPresentInSessionStorage(DISABLE_APQ_KEY);
}